import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

// 接口业务错误/请求异常时已用 Message 提示，此处 resolve 一个安全结果，避免未 catch 时触发 Uncaught runtime errors 遮罩
const API_ERROR_RESPONSE = { __apiErrorHandled: true, data: { rows: [], total: 0 } }

service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      if (response.status < 200 || response.status >= 300) {
        Message({ type: 'error', message: response.statusText || '请求失败' })
        return Promise.reject(new Error(response.statusText || '请求失败'))
      }
      return response.data
    }
    if (response.config.responseType === 'text') {
      if (response.status < 200 || response.status >= 300) {
        Message({ type: 'error', message: response.statusText || '请求失败' })
        return Promise.reject(new Error(response.statusText || '请求失败'))
      }
      return response.data
    }
    const res = response.data
    if (res.code !== 200) {
      Message({ type: 'error', message: res.msg || '请求失败' })
      if (res.code === 401) {
        store.dispatch('user/logout')
        window.location.hash = '#/login'
      }
      return Promise.resolve(API_ERROR_RESPONSE)
    }
    return res
  },
  error => {
    const msg = error.response && error.response.data && error.response.data.msg
      ? error.response.data.msg
      : (error.message || '网络错误')
    Message({ type: 'error', message: msg })
    if (error.response && error.response.status === 401) {
      store.dispatch('user/logout')
      window.location.hash = '#/login'
    }
    return Promise.resolve(API_ERROR_RESPONSE)
  }
)

export default service
